// extracted by mini-css-extract-plugin
export default {"snippetTitle":"styles_snippetTitle__FW7Uf"};